'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('ordersDesktopController', function (orderService, jobService, docketService, addressBookService, resourceService, userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
    mixpanel.track("Opened Orders Desktop");

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.originalOrder = null;
    $scope.preventReloadWithFilters = true;
    $scope.showFilters = false;
    $scope.listView = 'orders';
    $scope.selected = [];
    $scope.hasOrders = true
    $scope.myDocketbook = $state.params.myDocketbook
    $scope.customTemplate = [
      {
        name: 'Last 12 Months',
        dateStart: moment().subtract(12, 'months').toDate(),
        dateEnd: moment().toDate(),
      }
    ]

    orderService.getOrders({ limit: 1, offset: 0 }, function (returnData) {
      $scope.hasOrders = returnData.length > 0
    })

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $scope.assignOrder = {};
    $scope.assignOrder.selected = [];

    var statusFilterOptions = ['draft', 'sent', 'accepted', 'rejected', 'closed'];

    $scope.filters = {};
    $scope.filters.status = 'All';
    $scope.filters.startDate = moment().subtract(7, 'days').toDate();
    $scope.filters.endDate = moment().toDate();
    $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, accepted: true, rejected: true, closed: true };
    $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
    if ($scope.currentOrg && $scope.currentOrgGroup) {
      $scope.filters.organisationId = $scope.currentOrg.id;
      $scope.filters.groupId = $scope.currentOrgGroup.id;
    }

    $scope.$watch('dateFilterModel.dateStart', function (before, after) {
      if ($scope.dateFilterModel.dateStart) {
        $scope.filters.startDate = $scope.dateFilterModel.dateStart;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
      if ($scope.dateFilterModel.dateEnd) {
        $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    $scope.getStatus = function (order) {
      if (order == null) {
        return ''
      }

      if (userService.userCanDoAction('orderIsReviewable', order)) {
        return "Review";
      } else {
        return order.status;
      }
    }

    // New list query pagination
    $scope.query = {
      limit: 30,
      page: 1,
      order: 'orderNumber'
    };
    $scope.promise = null;

    if ($scope.currentOrg != null) {
      docketService.getTemplates({ published: true }, function (templates) {
        $scope.allTemplates = templates;
      });
      addressBookService.getAddressBook(null, function (addressBookFull) {
        $scope.addressBook = addressBookFull;
        $scope.addressBookSearchList = addressBookFull;
      });
      resourceService.getResources(null, function (allResources) {
        $scope.allResources = allResources;
        $scope.resourceSearchList = allResources;
      });
    }

    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    var loadSavedFilters = function () {
      var storedFilters = {};
      var lastOrdersFilters = {};
      if (sessionStorage.getItem('ordersLastFilters')) {
        lastOrdersFilters = JSON.parse(sessionStorage.getItem('ordersLastFilters'));
      }
      if (sessionStorage.getItem('filters')) {
        storedFilters = JSON.parse(sessionStorage.getItem('filters'));
        if (storedFilters.startDate != null) {
          $scope.filters.startDate = moment(storedFilters.startDate).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
        if (storedFilters.endDate != null) {
          $scope.filters.endDate = moment(storedFilters.endDate).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
        if (storedFilters.customerContact != null) {
          $scope.filters.customerContact = storedFilters.customerContact;
        }
        if (storedFilters.supplierContact != null) {
          $scope.filters.supplierContact = storedFilters.supplierContact;
        }
        if (storedFilters.orderNumber != null) {
          $scope.filters.orderNumber = storedFilters.orderNumber;
        } else if (lastOrdersFilters && lastOrdersFilters.orderNumber) {
          $scope.filters.orderNumber = lastOrdersFilters.orderNumber;
        }
        if (storedFilters.supplierRefNo != null) {
          $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
        } else if (lastOrdersFilters && lastOrdersFilters.supplierRefNo) {
          $scope.filters.supplierRefNo = lastOrdersFilters.supplierRefNo;
        }
        if (storedFilters.customerRefNo != null) {
          $scope.filters.customerRefNo = storedFilters.customerRefNo;
        } else if (lastOrdersFilters && lastOrdersFilters.customerRefNo) {
          $scope.filters.customerRefNo = lastOrdersFilters.customerRefNo;
        }
        if (storedFilters.reloadRequired) {
          $scope.filters.reloadRequired = storedFilters.reloadRequired;
        }
        // status filters
        /*if ( storedFilters.statusOptions ) {
          for ( var i = 0; i < statusFilterOptions.length; i++ ) {
            if ( storedFilters.statusOptions[statusFilterOptions[i]] == true ) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            } else {
              $scope.filters.statusOptions[statusFilterOptions[i]] = false;
            }
          }
          if ( storedFilters.statusOptions.all == true ) {
            $scope.filters.statusOptions.all = true;
            for ( var i = 0; i < statusFilterOptions.length; i++ ) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            }
          } else {
            $scope.filters.statusOptions.all = false;
          }
        }*/
        // if state params status is set - uisref status has been used and overrite status statusOptions
        /*if ( $stateParams.status != undefined ) {
          $scope.filters.statusOptions.all = false;
          for ( var i = 0; i < statusFilterOptions.length; i++ ) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = false;
          }
          $scope.filters.statusOptions[$stateParams.status] = true;
        }*/
        for (var i = 0; i < statusFilterOptions.length; i++) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }

        // load in most recent query params
        if (sessionStorage.getItem('ordersQuery') != null && sessionStorage.getItem('ordersQuery') != "undefined") {
          var queryStored = JSON.parse(sessionStorage.getItem('ordersQuery'));
          if (queryStored != null) {
            if (queryStored.limit) {
              $scope.query.limit = queryStored.limit;
            }
            if (queryStored.page) {
              $scope.query.page = queryStored.page;
            }
            if (queryStored.order) {
              $scope.query.order = queryStored.order;
            }
          }
        }
      }
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    }

    loadSavedFilters();

    /*** New Status Filters Helpers ***/

    $scope.prettifyFilterStatusPreview = function () {
      var output = "";

      if ($scope.filters.statusOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.statusOptions.draft) {
        soFar += 1;
        output += "Draft";
      }
      if ($scope.filters.statusOptions.sent) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Sent";
      }
      if ($scope.filters.statusOptions.accepted) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Accepted";
      }
      if ($scope.filters.statusOptions.rejected) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Rejected";
      }
      if ($scope.filters.statusOptions.closed) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Closed";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.statusFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in statusFilterOptions) {
        if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == statusFilterOptions.length) {
        $scope.filters.statusOptions.all = true;
      } else {
        $scope.filters.statusOptions.all = false;
        $scope.filters.statusOptions.allView = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('status options');
      }
    };

    $scope.swapStatusFilter = function (option) {
      if (option == 'all' && $scope.filters.statusOptions.all == false) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
        $scope.filters.statusOptions.allView = true;
        $scope.filters.statusOptions.all = true;
      } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        }
        $scope.filters.statusOptions.allView = false;
        $scope.filters.statusOptions.all = false;
      }
      $scope.statusFiltersChanged();
    }

    $scope.setOnlyFilter = function (option) {
      $scope.filters.statusOptions.all = false;
      for (var i in statusFilterOptions) {
        if (statusFilterOptions[i] != option) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        } else {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
      }
      $scope.statusFiltersChanged();
    }

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.itemEditClosed = function (itemEdit) {
      if (itemEdit && !itemEdit.editing) {
        return true;
      } else {
        return false;
      }
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      //originatorEv = ev;
      $mdOpenMenu(ev);
    };

    /**************************************/
    /***** Order Detail View Controls *****/
    /**************************************/

    var openOrder = function (order) {
      $scope.orderLoadingError = null;
      $scope.currentOrder = order;
      $scope.listView = 'orders';
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.prepareForOrderFromParent(null, order);
      orderService.getOrder(order, function (fullOrder) {
        // setup line item quantities
        for (var i = 0; i < fullOrder.lineItems.length; i++) {
          if (fullOrder.lineItems[i].resource && fullOrder.lineItems[i].resource.uom.isTime) {
            var quantity = fullOrder.lineItems[i].quantity;
            var hours = Math.floor(quantity / 60);
            var minutes = quantity % 60;
            fullOrder.lineItems[i].quantityHoursEdit = hours;
            fullOrder.lineItems[i].quantityMinutesEdit = minutes;
          } else {
            fullOrder.lineItems[i].quantityEdit = fullOrder.lineItems[i].quantity;
          }
        }
        $scope.originalOrder = angular.copy(fullOrder);
        $scope.loadOrderFromParent(fullOrder);
      }, function (err) {
        $scope.orderLoadingErrorFull = err;
        $scope.orderLoadingError = "Error Getting Order";
      });
    }

    $scope.openOrderDesktop = function (order, skipDiffCheck) {
      var currentOrder = $scope.getOrderFromParent();
      var orderId = order;
      if (orderId.id != null) {
        orderId = orderId.id;
      }
      if (currentOrder && currentOrder.id == orderId) {
        return;
      }
      if (skipDiffCheck && skipDiffCheck == true) {
        if ($scope.currentOrg) {
          $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
        } else {
          $state.go('main.orderDetail', { orderId: order.id });
        }
        return;
      }
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0 || currentOrder.id == null) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  if ($scope.currentOrg) {
                    $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
                  } else {
                    $state.go('main.orderDetail', { orderId: order.id });
                  }
                });
              } else if (actionSelected == 'dontSave') {
                if ($scope.currentOrg) {
                  $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
                } else {
                  $state.go('main.orderDetail', { orderId: order.id });
                }
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            if ($scope.currentOrg) {
              $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
            } else {
              $state.go('main.orderDetail', { orderId: order.id });
            }
          }
        });
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
        } else {
          $state.go('main.orderDetail', { orderId: order.id });
        }
      }
    }

    var closeOrder = function () {
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.maximiseList();
    }

    $scope.closeOrder = closeOrder;

    $scope.closeOrderDesktop = function () {
      // check if existing order is in edit mode and has unsaved changes
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing && !currentOrder.newOrder) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  if ($scope.currentOrg) {
                    $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                  } else {
                    $state.go('main.orders');
                  }
                });
              } else if (actionSelected == 'dontSave') {
                if ($scope.currentOrg) {
                  $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.orders');
                }
              }
            });
          } else {
            if ($scope.currentOrg) {
              $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.orders');
            }
          }
        });
      } else {
        $scope.closeOrder()
        if ($scope.currentOrg) {
          $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.orders');
        }
      }
    }

    var newOrder = function () {
      $scope.listView = 'orders';
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.newOrderFromParent();
      $scope.originalOrder = {};
    }

    $scope.goToNewOrder = function (fromOption) {
      if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.quotesEnabled && fromOption == 'xeroQuote') {
        $scope.quoteSelectFromParent(function (quoteSelected) {
          if (quoteSelected != null) {
            $scope.listView = 'orders';
            $scope.splitListFunc.slideTableListDetailOpen();
            $scope.minimiseList();
            $scope.newOrderFromParent('fromXeroQuote', quoteSelected);
            $scope.originalOrder = {};
          }
        });
      } else {
        $scope.listView = 'orders';
        $scope.splitListFunc.slideTableListDetailOpen();
        $scope.minimiseList();
        $scope.newOrderFromParent();
        $scope.originalOrder = {};
      }
    }

    $scope.newOrder = function (fromOption) {
      // check if existing order is in edit mode and has unsaved changes
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  $scope.goToNewOrder(fromOption);
                  //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
                });
              } else if (actionSelected == 'dontSave') {
                $scope.goToNewOrder(fromOption);
                //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $scope.goToNewOrder(fromOption);
            //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
          }
        });
      } else {
        $scope.goToNewOrder(fromOption);
        //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
      }
    }

    $scope.saveOrder = function (order, cb) {
      var newOrder = false;
      if (order.id == null) {
        newOrder = true;
      }
      order.loading = true;
      order.loadingType = "saving";

      // convert quantities for line items back
      if (order.lineItems) {
        for (var i = 0; i < order.lineItems.length; i++) {
          if (order.lineItems[i].resource) {
            if (order.lineItems[i].resource.uom.isTime) {
              var totalMinutes = 0;
              if (order.lineItems[i].quantityHoursEdit) {
                totalMinutes += parseInt(order.lineItems[i].quantityHoursEdit) * 60;
              }
              if (order.lineItems[i].quantityMinutesEdit) {
                totalMinutes += parseInt(order.lineItems[i].quantityMinutesEdit);
              }
              order.lineItems[i].quantity = totalMinutes;
            } else {
              order.lineItems[i].quantity = order.lineItems[i].quantityEdit;
            }
          } else {
            order.lineItems[i].quantity = order.lineItems[i].quantityEdit;
          }
        }
      }

      // docket prefill field stores - update any date fields and save in correct format
      if (order.docketPrefillValueStore && order.template) {
        var prefillKeys = Object.keys(order.docketPrefillValueStore);
        for (var i = 0; i < prefillKeys.length; i++) {
          // check against template if this field id is a date field
          for (var j = 0; j < order.template.blocks.length; j++) {
            for (var k = 0; k < order.template.blocks[j].fields.length; k++) {
              if (order.template.blocks[j].fields[k].id == prefillKeys[i] && order.template.blocks[j].fields[k].type == 'date') {
                var preValue = order.docketPrefillValueStore[prefillKeys[i]];
                var translatedValue = moment(preValue).format('YYYY-MM-DD');
                translatedValue += "T00:00:00.000Z";
                order.docketPrefillValueStore[prefillKeys[i]] = translatedValue;
              }
            }
          }
        }
      }

      // Get order diff
      orderService.getOrderDiff($scope.originalOrder, order, function (diffedOrder, diffCount) {
        if (diffCount > 0 || newOrder == true) {
          orderService.saveOrder(diffedOrder, function (orderUpdated) {
            if (newOrder) {
              if (!cb) {
                // add reloadRequired = true
                $scope.filters.reloadRequired = true;
                sessionStorage.setItem('filters', JSON.stringify($scope.filters));
                $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: orderUpdated.id });
                return;
              }
            } else {
              $scope.showToast('Order Changed Saved');
            }
            $scope.originalOrder = order;
            if (!cb) {
              openOrder(orderUpdated.id);
              $scope.loadOrdersList();
            } else {
              cb();
            }
          }, function (err) {
            $scope.alertService.presentAutoAlert('saveOrder', err);
            order.loading = false;
          });
        } else {
          order.loading = false;
          if (newOrder) {
            $scope.showToast('New Order Saved');
          } else {
            $scope.showToast('Order Changed Saved');
          }
          $scope.originalOrder = order;
          if (!cb) {
            openOrder(order.id);
            $scope.loadOrdersList();
          } else {
            cb();
          }
        }
      });
    }

    $scope.removeOrderFromCachedList = function (order) {
      var ordersListParsed = JSON.parse(sessionStorage.getItem('ordersList'));
      if (ordersListParsed) {
        var newList = [];
        for (var i = 0; i < ordersListParsed.length; i++) {
          if (ordersListParsed[i].id != order.id) {
            newList.push(ordersListParsed[i]);
          }
        }
        sessionStorage.setItem('ordersList', JSON.stringify(newList));
      }
    }

    $scope.deleteOrder = function (order) {
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          $scope.removeOrderFromCachedList(order);
          orderService.deleteOrder(order.id, function () {
            if ($scope.currentOrg) {
              $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.orders');
            }
          });
        }
      });
    }

    $scope.editOrder = function (order) {
      order.editing = true;
    }

    $scope.cancelEditOrder = function (order) {
      order.editing = false;

      var newOrder = false;
      if (order.id == null) {
        newOrder = true;
      }

      if (newOrder) {
        $scope.closeOrder()
      } else {
        openOrder(order);
      }
    }

    $scope.reDraftOrder = function (order) {
      order.loading = true;
      order.loadingType = 'saving';
      orderService.reDraftOrder(order, function (orderUpdated) {
        openOrder(orderUpdated.id);
        $scope.loadOrdersList();
      }, function (error) {
        $scope.showToast('Error Re-Drafting Order');
        order.loading = false;
      });
    }

    $scope.sendOrder = function (order) {
      order.loading = true;
      order.loadingType = 'saving';

      // validate parameters before trying to save order
      orderService.validateSendOrder(order, function () {
        orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
          if (diffCount > 0) {
            orderService.saveOrder(diff, function (orderUpdated) {
              sendOrder(orderUpdated);
            }, function (err) {
              $scope.alertService.presentAutoAlert('saveOrder', err);
              order.loading = false;
            });
          } else {
            sendOrder(order);
          }
        });
      }, function (exceptions) {
        order.loading = false;
        $scope.alertService.presentAutoValidationAlert('sendOrder', exceptions);
      });
    }

    var sendOrder = function (order) {
      orderService.sendOrder(order, function (order) {
        $scope.originalOrder = order;
        openOrder(order.id);
        $scope.loadOrdersList();
      }, function (error) {
        $scope.alertService.presentAutoAlert('sendOrder', error);
        order.loading = false;
      });
    }

    $scope.acceptOrder = function (order, successCb, failureCb) {
      order.loading = true;
      order.loadingType = 'saving';


      if (userService.userCanDoAction('isOrderSupplier', order) && !order.template) {
        order.template = $scope.currentOrgGroup.defaultTemplate;
      }

      orderService.validateAcceptOrder(order, function () {
        orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
          if (diffCount > 0) {
            orderService.saveOrder(diff, function (orderUpdated) {
              acceptOrder(orderUpdated, successCb, failureCb);
            }, function (err) {
              $scope.alertService.presentAutoAlert('saveOrder', err);
            });
          } else {
            acceptOrder(order, successCb, failureCb);
          }
        });
      }, function (exceptions) {
        order.loading = false;
        $scope.alertService.presentAutoValidationAlert('acceptOrder', exceptions);
      });
    }

    var acceptOrder = function (order, successCb, failureCb) {
      orderService.acceptOrder(order, function (orderUpdated) {
        openOrder(orderUpdated.id);
        $scope.loadOrdersList();
        if (successCb) {
          successCb();
        }
      }, function (err) {
        $scope.alertService.presentAutoAlert('acceptOrder', error);
        order.loading = false;
        if (failureCb) {
          failureCb();
        }
      });
    }

    $scope.rejectOrder = function (order) {
      order.loading = true;
      order.loadingType = 'saving';
      orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
        if (diffCount > 0) {
          orderService.saveOrder(diff, function (orderUpdated) {
            rejectOrder(orderUpdated);
          }, function (err) {
            $scope.alertService.presentAutoAlert('saveOrder', err);
          });
        } else {
          rejectOrder(order);
        }
      });
    }

    var rejectOrder = function (order) {
      orderService.rejectOrder(order, function (orderUpdated) {
        openOrder(orderUpdated.id);
        $scope.loadOrdersList();
      }, function (err) {
        $scope.alertService.presentAutoAlert('rejectOrder', err);
        order.loading = false;
      });
    }

    $scope.finishOrder = function (order) {
      order.loading = true;
      order.loadingType = 'saving';

      var buttonActions = [{ title: "Confirm", action: 'confirm', colour: 'red' },
      { title: "Cancel", action: 'cancel', colour: 'grey' }];
      var buttonSelected = function (selectedOption) {
        switch (selectedOption) {
          case "confirm":
            orderService.closeOrder(order, function (orderUpdated) {
              if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled == true && $scope.currentOrg.planFeatures.accountingIntegrationEnabled == true && order.supplierRefNo && order.supplierRefNo.indexOf('xq') == 0) {
                // get quote ID
                var splits = order.supplierRefNo.split('_');
                xeroService.markXeroQuoteInvoiced(splits[2], function (success) {
                  openOrder(orderUpdated.id);
                  $scope.loadOrdersList();
                }, function (failed) {
                  openOrder(orderUpdated.id);
                  $scope.loadOrdersList();
                });
              } else {
                openOrder(orderUpdated.id);
                $scope.loadOrdersList();
              }
            }, function (error) {
              $scope.alertService.presentAutoAlert('closeOrder', error);
              order.loading = false;
            });
            break;
          default:
        };
      }
      $scope.alertService.presentConfirmAlert('Confirm Close',
        'Are you sure you want to close this order? You will no longer be able to create Jobs or Dockets.',
        buttonActions,
        buttonSelected
      );
    }

    /********************************************/
    /***** Create New Docket/Job From Order *****/
    /********************************************/

    $scope.jobsListForOrder = function (order) {
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupJobs', { orderId: order.id, orderNumber: order.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }

    $scope.newJobFromOrder = function (order) {
      // First check if order has been saved?
      var currentOrder = $scope.getOrderFromParent();
      orderService.validateCreateJob(order, function () {
        if (currentOrder != null && currentOrder.editing) {
          orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
            if (diffCount > 0) {
              var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
              $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
                if (actionSelected == 'save') {
                  $scope.saveOrder(currentOrder, function () {
                    $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                  });
                } else if (actionSelected == 'dontSave') {
                  $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  // do nothing - stay where we are
                }
              });
            } else {
              $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      }, function (exceptions) {
        order.loading = false;
        $scope.alertService.presentAutoValidationAlert('orderCreateJob', exceptions);
      });
    }

    $scope.docketsListForOrder = function (order) {
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupDockets', { orderId: order.id, orderNumber: order.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }

    $scope.newDocketFromOrder = function (order) {
      // First check if order has been saved?
      var currentOrder = $scope.getOrderFromParent();
      orderService.validateCreateJob(order, function () {
        if (currentOrder != null && currentOrder.editing) {
          orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
            if (diffCount > 0) {
              var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
              $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
                if (actionSelected == 'save') {
                  $scope.saveOrder(currentOrder, function () {
                    $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                  });
                } else if (actionSelected == 'dontSave') {
                  $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  // do nothing - stay where we are
                }
              });
            } else {
              $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      }, function (exceptions) {
        order.loading = false;
        $scope.alertService.presentAutoValidationAlert('orderCreateDocket', exceptions);
      });
    }

    /**********************************/
    /***** Bulk Selection Helpers *****/
    /**********************************/

    $scope.bulkSelectionDelete = function () {
      var itemsToDelete = $scope.selected;
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete these " + itemsToDelete.length + " orders?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          orderService.deleteBulkOrders(itemsToDelete, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkOrders', { status: 202, requestName: 'Delete bulk orders - failures ' + failures.length + ' of ' + itemsToDelete.length });
              $scope.loadOrdersList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkOrders', { status: 200 });
              $scope.loadOrdersList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionSend = function () {
      var itemsToSend = $scope.selected;
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to send these " + itemsToSend.length + " orders?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, send them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          orderService.sendBulkOrders(itemsToSend, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('sendBulkOrders', { status: 202, requestName: 'Send bulk orders - failures ' + failures.length + ' of ' + itemsToSend.length });
              $scope.loadOrdersList();
            } else {
              $scope.alertService.presentAutoAlert('sendBulkOrders', { status: 200 });
              $scope.loadOrdersList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionAccept = function () {
      var itemsTo = $scope.selected;
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to accept these " + itemsTo.length + " orders?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, accept them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          orderService.acceptBulkOrders(itemsTo, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('acceptBulkOrders', { status: 202, requestName: 'Accept bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
              $scope.loadOrdersList();
            } else {
              $scope.alertService.presentAutoAlert('acceptBulkOrders', { status: 200 });
              $scope.loadOrdersList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionReject = function () {
      var itemsTo = $scope.selected;
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to reject these " + itemsTo.length + " orders?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, reject them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          orderService.rejectBulkOrders(itemsTo, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('rejectBulkOrders', { status: 202, requestName: 'Reject bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
              $scope.loadOrdersList();
            } else {
              $scope.alertService.presentAutoAlert('rejectBulkOrders', { status: 200 });
              $scope.loadOrdersList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionClose = function () {
      var itemsTo = $scope.selected;
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.clearOrderFromParent();
      $scope.splitListFunc.slideTableListDetailClosed();
      swal({
        title: "Are you sure?",
        text: "Do you really want to close these " + itemsTo.length + " orders?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, close them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          orderService.closeBulkOrders(itemsTo, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('closeBulkOrders', { status: 202, requestName: 'Close bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
              $scope.loadOrdersList();
            } else {
              $scope.alertService.presentAutoAlert('closeBulkOrders', { status: 200 });
              $scope.loadOrdersList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    /********************************/
    /****** Order List Controls *****/
    /********************************/

    $scope.filtersChanged = function (from) {
      if (!$scope.preventReloadWithFilters) {
        // check toDate is after fromDate
        if (moment($scope.filters.endDate).isBefore($scope.filters.startDate)) {
          $scope.filters.endDate = $scope.filters.startDate;
        }

        $scope.query.page = 1;

        $scope.loadOrdersList();
        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      }
    }

    $scope.ordersChildControllerReady = function () {
      // check stateParams for any filter presets
      if ($scope.currentOrg && sessionStorage.getItem('ordersList') != undefined) {
        // check if last stored orders filters is the same as current filters
        var lastOrdersFilters = {};
        if (sessionStorage.getItem('ordersLastFilters')) {
          lastOrdersFilters = JSON.parse(sessionStorage.getItem('ordersLastFilters'));
        }
        var loadNew = false;
        if (sessionStorage.getItem('filters')) {
          var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
          if (storedFilters.reloadRequired == true) {
            loadNew = true;
            $scope.filters.reloadRequired = false;
          }
        }
        if (lastOrdersFilters && lastOrdersFilters != undefined) {
          if (lastOrdersFilters.organisationId != $scope.currentOrg.id || lastOrdersFilters.groupId != $scope.currentOrgGroup.id) {
            loadNew = true;
          }
          if (lastOrdersFilters.startDate && moment(lastOrdersFilters.startDate).diff(moment($scope.filters.startDate), 'days') != 0) {
            loadNew = true;
          } else if (lastOrdersFilters.endDate && moment(lastOrdersFilters.endDate).diff(moment($scope.filters.endDate), 'days') != 0) {
            loadNew = true;
          }
          // check if status options have changed
          if (lastOrdersFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
            loadNew = true;
          } else {
            for (var i = 0; i < statusFilterOptions.length; i++) {
              if (lastOrdersFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
                loadNew = true;
              }
            }
          }
          if (lastOrdersFilters.customerContact && !$scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastOrdersFilters.customerContact && $scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastOrdersFilters.customerContact && !$scope.filters.customerContact) {
            // do nothing
          } else if (lastOrdersFilters.customerContact.id != $scope.filters.customerContact.id) {
            loadNew = true;
          }
          if (lastOrdersFilters.supplierContact && !$scope.filters.supplierContact) {
            loadNew = true;
          } else if (!lastOrdersFilters.supplierContact && $scope.filters.supplierContact) {
            loadNew = true;
          } else if (!lastOrdersFilters.supplierContact && !$scope.filters.supplierContact) {
            // do nothing
          } else if (lastOrdersFilters.supplierContact.id != $scope.filters.supplierContact.id) {
            loadNew = true;
          }
        } else {
          // no previous filters stored, load new list
          loadNew = true;
        }

        if (loadNew) {
          $scope.query.page = 1;
          $scope.loadOrdersList();
        } else {
          var ordersListParsed = JSON.parse(sessionStorage.getItem('ordersList'));
          var ordersListCount = JSON.parse(sessionStorage.getItem('ordersListCount'));
          $scope.loadOrdersListFromParent(ordersListParsed, ordersListCount);
          $scope.preventReloadWithFilters = false;
        }
      } else {
        $scope.loadOrdersList();
      }
    }

    $scope.detailControllerReady = function () {
      // Parameter controls to open specific order
      if ($stateParams.orderId != null) {
        if ($stateParams.orderId == 'new') {
          newOrder();
        } else {
          openOrder($stateParams.orderId);
        }
      }
    }

    $scope.loadOrdersListFromMdTable = function () {
      $scope.loadOrdersList();
    }

    $scope.loadOrdersList = function (searchValue, reload) {
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        params['limit'] = $scope.query.limit;
        params['offset'] = $scope.query.limit * ($scope.query.page - 1);
        params['sort'] = $scope.query.order;
        params['prioritizePending'] = true;
        if (searchValue != null && searchValue != "") {
          params['search'] = searchValue;
        }

        orderService.getOrders(params, function (returnData) {
          var ordersListParsed = orderService.parseOrders(returnData);
          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.loadOrdersListFromParent(ordersListParsed, count);
          if (reload && reload == true) {
            var currentOrder = $scope.getOrderFromParent();
            if (currentOrder && !currentOrder.editing && currentOrder.id != null) {
              openOrder(currentOrder.id);
            }
          }
          $scope.preventReloadWithFilters = false;
          // store list in sessionStorage
          sessionStorage.setItem('ordersList', JSON.stringify(ordersListParsed));
          sessionStorage.setItem('ordersListCount', count);
          sessionStorage.setItem('ordersQuery', JSON.stringify($scope.query));
          sessionStorage.setItem('filters', JSON.stringify($scope.filters));
          sessionStorage.setItem('ordersLastFilters', JSON.stringify($scope.filters));
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.selectContactFilter = function (type) {
      var existingContact = null;
      if (type == 'customer') {
        if ($scope.filters.customerContact != null) {
          existingContact = $scope.filters.customerContact;
        }
      } else {
        if ($scope.filters.supplierContact != null) {
          existingContact = $scope.filters.supplierContact;
        }
      }
      $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
        if (contactSelected != null) {
          if (type == 'customer') {
            $scope.filters.customerContact = contactSelected;
          } else {
            $scope.filters.supplierContact = contactSelected;
          }
          $scope.filtersChanged(type);
        }
      });
    }

    $scope.editContactForOrder = function (contactItem, cb) {
      $scope.editContactFromParent(contactItem, function (contactEdited) {
        cb(contactEdited);
      });
    }

    $scope.selectContactForShare = function (cb) {
      $scope.contactSelectFromParent(null, null, function (contactSelected) {
        cb(contactSelected);
      });
    }

    $scope.selectContactForOrder = function (order, companyType, cb) {
      $scope.selectContactCallback = cb;
      var existingContacts = [];
      var selectedContact = null;
      if (companyType == 'customerContact') {
        if (order.supplierContact != null) {
          existingContacts.push(order.supplierContact);
        }
        if (order.customerContact != null) {
          selectedContact = order.customerContact;
        }
      } else if (companyType == 'supplierContact') {
        if (order.customerContact != null) {
          existingContacts.push(order.customerContact);
        }
        if (order.supplierContact != null) {
          selectedContact = order.supplierContact;
        }
      }

      if (selectedContact) {
        var newContactAddresses = [];
        var keys = Object.keys(selectedContact.contactAddresses);
        for (var i = 0; i < keys.length; i++) {
          var newContactAddress = {};
          newContactAddress.emailAddress = keys[i]
          newContactAddress.accessLevel = selectedContact.contactAddresses[keys[i]][0];
          newContactAddresses.push(newContactAddress);
        }
        selectedContact.contactAddresses = newContactAddresses;
        for (var i = 0; i < selectedContact.addresses.length; i++) {
          var address = selectedContact.addresses[i];
          if (address.streetNum == null) {
            delete address.streetNum;
          }
          if (address.streetName == null) {
            delete address.streetName;
          }
        }
      }

      $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
        $scope.selectContactCallback(contactSelected);
      });
    }

    $scope.selectTemplateForOrder = function (sourceList, cb) {
      $scope.selectTemplateCallback = cb;
      $scope.templateSelectFromParent(sourceList, function (templateSelected) {
        $scope.selectTemplateCallback(templateSelected);
      });
    }

    $scope.selectResourceForOrder = function (options, cb) {
      $scope.selectResourceCallback = cb;
      $scope.desktopResourceSelectFromParent(options, function (resourcesSelected) {
        $scope.selectResourceCallback(resourcesSelected);
      });
    }

    $scope.selectOrganisationForOrder = function (order, cb) {
      $("#assignOrderModal").fadeIn(100);
      $scope.selectOrganisationCallback = cb;
      $scope.assignOrder = {};
      $scope.assignOrder.selected = [];
      $scope.assignOrder.orderNumber = order.orderNumber;
      $scope.assignOrder.organisations = accessControl.allowedOrganisations();
    }

    $scope.assignOrderContinue = function () {
      var group = $scope.assignOrder.selected[0];
      $("#assignOrderModal").fadeOut(100);
      $scope.selectOrganisationCallback(group);
    }

    $scope.closeAssignOrderModal = function () {
      $("#assignOrderModal").fadeOut(100);
      $scope.selectOrganisationCallback(null, null);
    }

    /******************************************/
    /**** List Selector & Search Controls *****/
    /******************************************/

    $scope.searchCustomerChange = function (item, searchText) {
      if (searchText == "") {
        $scope.addressBookSearchList = $scope.addressBook;
        return;
      }

      var filteredList = [];
      for (var i = 0; i < $scope.addressBook.length; i++) {
        if ($scope.addressBook[i].displayName.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          filteredList.push($scope.addressBook[i]);
        }
      }

      $scope.addressBookSearchList = filteredList;
    }

    $scope.searchSupplierChange = function (item, searchText) {
      if (searchText == "") {
        $scope.addressBookSearchList = $scope.addressBook;
        return;
      }

      var filteredList = [];
      for (var i = 0; i < $scope.addressBook.length; i++) {
        if ($scope.addressBook[i].displayName.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          filteredList.push($scope.addressBook[i]);
        }
      }

      $scope.addressBookSearchList = filteredList;
    }

    $scope.selectCustomerChange = function (orderEdit) {
      // make sure customer contact is formatted correctly
      if (orderEdit.customerContact != null) {
        var newContactAddresses = {};
        for (var i = 0; i < orderEdit.customerContact.contactAddresses.length; i++) {
          newContactAddresses[orderEdit.customerContact.contactAddresses[i].emailAddress] = ['approver'];
        }
        orderEdit.customerContact.contactAddresses = newContactAddresses;
      }
    }

    $scope.selectSupplierChange = function (orderEdit) {
      // make sure supplier contact is formatted correctly
      if (orderEdit.supplierContact) {
        var newContactAddresses = {};
        for (var i = 0; i < orderEdit.supplierContact.contactAddresses.length; i++) {
          newContactAddresses[orderEdit.supplierContact.contactAddresses[i].emailAddress] = ['approver'];
        }
        orderEdit.supplierContact.contactAddresses = newContactAddresses;
      }
    }

    /*******************/
    /***** Filters *****/
    /*******************/

    $scope.toggleFilters = function () {
      $scope.showFilters = !$scope.showFilters;
    }

    $scope.resetAllFilters = function () {
      // SETUP filters
      $scope.filters = {};
      $scope.filters.status = 'All';
      $scope.filters.startFromDate = null;//moment().subtract(7,'days').toDate();
      $scope.filters.startToDate = null;
      $scope.filters.endFromDate = moment().subtract(7, 'days').toDate();
      $scope.filters.endToDate = null;
      $scope.filters.orderNumber = null;
      $scope.filters.supplierRefNo = null;
      $scope.filters.customerRefNo = null;
    }

    $scope.searchOrdersChange = function (value) {
      $scope.loadOrdersList(value);
    }

    $scope.clearFilters = function () {
      $scope.filters.customerContact = null;
      $scope.filters.supplierContact = null;
      $scope.filters.customerRefNo = null;
      $scope.filters.supplierRefNo = null;
      $scope.filters.orderNumber = null;
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
      // reset date filters
      $scope.filters.startDate = moment().subtract(7, 'days').toDate(); //startFromDate
      $scope.filters.endDate = moment().toDate(); //endToDate
      $scope.dateFilterModel.dateStart = moment().subtract(7, 'days').toDate();
      $scope.dateFilterModel.dateEnd = moment().toDate();
      $scope.filtersChanged('cleared');
      window.location.reload();
    }

    $scope.clearFilterItem = function (name) {
      $scope.filters[name] = null;
      $scope.filtersChanged(name);
    }

    $scope.clearFilterDateSet = function (firstDate, secondDate) {
      $scope.filters[firstDate] = null;
      $scope.filters[secondDate] = null;
    }

    $scope.getFilterParams = function () {
      var params = {};
      if ($scope.filters.endDate != null) {
        var startToDate = moment($scope.filters.endDate);
        params.startToDate = startToDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.startDate != null) {
        var endFromDate = moment($scope.filters.startDate);
        params.endFromDate = endFromDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.statusOptions.all == true) {
        params['status'] = null;
      } else {
        var statusParam = "";
        var count = 0;
        for (var i in statusFilterOptions) {
          if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
            count += 1;
            if (count > 1) {
              statusParam += ",";
            }
            statusParam += statusFilterOptions[i];
          }
        }
        params['statusList'] = statusParam;
        params['status'] = null;
      }
      if ($scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "") {
        params.supplierRefNo = $scope.filters.supplierRefNo;
      }
      if ($scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "") {
        params.customerRefNo = $scope.filters.customerRefNo;
      }
      if ($scope.filters.customerContact != null) {
        if ($scope.filters.customerContact.contactAddresses.length > 0) {
          var customerAddresses = [];
          for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
            customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
          }
          params.customer = customerAddresses.join(',');
        } else {
          params.search = $scope.filters.customerContact.displayName;
        }
      }
      if ($scope.filters.supplierContact != null) {
        var supplierAddresses = [];
        for (var i = 0; i < $scope.filters.supplierContact.contactAddresses.length; i++) {
          supplierAddresses.push($scope.filters.supplierContact.contactAddresses[i].emailAddress);
        }
        params.supplier = supplierAddresses.join(',');
      }
      if ($scope.filters.orderNumber != null && $scope.filters.orderNumber != "") {
        params.orderNumber = $scope.filters.orderNumber;
      }

      return params;
    }

    /*$scope.updateFilterHeading = function() {
      var newHeading = "Filtered by";
      var filterCount = 0;
      if ( $scope.filters.customerContact != null ) {
        newHeading += " customer " + $scope.filters.customerContact.displayName + ",";
        filterCount += 1;
      }
      if ( $scope.filters.supplierContact != null ) {
        newHeading += " supplier " + $scope.filters.supplierContact.displayName + ",";
        filterCount += 1;
      }
      if ( $scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "" ) {
        newHeading += " customer ref no " + $scope.filters.customerRefNo + ",";
        filterCount += 1;
      }
      if ( $scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "" ) {
        newHeading += " supplier ref no " + $scope.filters.supplierRefNo + ",";
        filterCount += 1;
      }
      if ( $scope.filters.startFromDate != null || $scope.filters.endToDate != null || $scope.filters.startToDate != null || $scope.filters.endFromDate != null ) {
        newHeading += " date range,";
        filterCount += 1;
      }
      if ( newHeading[newHeading.length - 1] == "," ) {
        newHeading = newHeading.substring(0, newHeading.length - 1);
      }
      if ( filterCount > 0 ) {
        $scope.activeFilters = filterCount;
        $scope.filterHeading = newHeading;
      } else {
        $scope.activeFilters = 0;
        $scope.filterHeading = "";
      }
    }*/

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }
  });



// WEBPACK FOOTER //
// ./src/controllers/orders/desktopController.js